import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';
import { type DriverLocation } from '../../data/models/driver-location.model';
import {
  setDriverLocation,
  setDriverLocationForDriverId,
  setDriverLocationForTripLegReferenceId,
} from '../../data/driver.slice';

enum DriverLocationEventType {
  DriverLocationUpdate = 'DriverLocationUpdate',
}

type DriverLocationDetail = {
  transportationProviderID: number;
  tripLegReferenceID: string;
  clientID: string;
  passengerID: string;
  driverLocation: DriverLocation;
};

function updateDriverLocation(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: DriverLocationEventType,
  detail: DriverLocationDetail,
) {
  const { driverLocation: location, tripLegReferenceID } = detail;
  switch (detailType) {
    case DriverLocationEventType.DriverLocationUpdate:
      dispatch(setDriverLocation(location));
      if (location.driverID) {
        dispatch(
          setDriverLocationForDriverId({
            driverID: location.driverID,
            location,
          }),
        );
      }
      if (tripLegReferenceID) {
        dispatch(
          setDriverLocationForTripLegReferenceId({
            tripLegReferenceID,
            location,
          }),
        );
      }
      break;
  }
}

export { DriverLocationEventType, updateDriverLocation };
